import React from "react";
import {useHistory} from "react-router-dom";
import * as auth from "../_redux/authRedux";
import {connect} from "react-redux";

function AutoLogin(props) {
	const history = useHistory()
	const {params} = props.match
	if (!params.token) {
		setTimeout(() => {
			history.push(`/auth/login`)
		}, 300)
	} else {
		props.login({authToken: params.token});
	}
	return (
		""
	)
}

export default (connect(null, auth.actions)(AutoLogin));
